import { render, staticRenderFns } from "./OverlayElement.vue?vue&type=template&id=3ab1f560"
import script from "./OverlayElement.vue?vue&type=script&lang=ts"
export * from "./OverlayElement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports